import React, { useEffect } from 'react';
import useTopPanel from 'hooks/useTopPanel';
import WarehouseChecklist from './WarehouseChecklist';
import WarehouseChecklistWithValue from './WarehouseChecklistWithValue';
import { Tab, Tabs } from '@mui/material';

function CheckList() {
  const [tabIndex, setTabIndex] = React.useState(1);

  const { setComponent } = useTopPanel();
  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    setComponent(
      <>
        <Tabs
          value={tabIndex}
          onChange={handleChangeTab}
          sx={{ minHeight: 30 }}
        >
          <Tab
            label={"Mavjud bo'lgan mahsulotlarni ko'rish"}
            value={1}
            sx={{ minHeight: 30, padding: '2px 16px' }}
          />
          <Tab
            label={'Mahsulotlar yetish pragnozi'}
            value={2}
            sx={{ minHeight: 30, padding: '2px 16px' }}
          />
        </Tabs>
      </>
    );
  }, [tabIndex]);

  return tabIndex == 1 ? (
    <WarehouseChecklist />
  ) : (
    <WarehouseChecklistWithValue />
  );
}

export default React.memo(CheckList);
